import { render, staticRenderFns } from "./ShipBluTr.vue?vue&type=template&id=47f10684"
import script from "./ShipBluTr.vue?vue&type=script&lang=js"
export * from "./ShipBluTr.vue?vue&type=script&lang=js"
import style0 from "./ShipBluTr.vue?vue&type=style&index=0&id=47f10684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports